import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { DetailEcommerceDialog } from '@app/@shared/dialogs/detail-ecommerce/detail-ecommerce.component';
import { DetailSignatureDigitalDialog } from '@app/@shared/dialogs/detail-signatureDigital/detail-signature-digital.component';
import { DetailTpvEcommerceDialog } from '@app/@shared/dialogs/detail-tpv-ecommerce/detail-tpv-ecommerce.component';
import { AdminStore } from '../admin-service/admin-service.store';
import { EcommerceReportDTO } from '../model/users-model';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import { CustomValidatorsService } from '@app/@shared/custom-validators/custom-validators.service';
import { ExcelService } from '@app/@shared/services/print/excel.service';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { TranslateService } from '@ngx-translate/core';
import { DatepickerUtilsService } from '@app/@shared/services/utils/datepicker-utils.service';
import { LOCALE_ES } from '@app/@core/constants/common.constants';
import moment from 'moment';

@UntilDestroy()
@Component({
  selector: 'app-ecommerce',
  templateUrl: './ecommerce.component.html',
  styleUrls: ['./ecommerce.component.scss'],
})
export class EcommerceComponent implements OnInit {
  ecommerceForm: FormGroup;

  maxDate: Date = new Date();
  maxFinalDate: Date = new Date();
  minDate: Date;

  hasCalledOnce: boolean = false;

  //Order of the headers' labels displayed in the table, using id
  displayedColumns = [
    'idEcommerce',
    'guidOperation',
    'numOperation',
    'codeTPV',
    'reference',
    'guidLogaltyCheck',
    'guidLogaltyContract',
    'owner',
    'status',
  ];

  columnsToDisplay: any[] = this.displayedColumns.slice();
  head = [
    [
      'ID Ecommerce',
      'GUID Op Ecommerce',
      'Nº Solicitud',
      'Cod. Auto. TPV',
      'Ref. Pedido',
      'GUID Logalty Check',
      'GUID Logalty Contrato',
      'Titular',
      'Estado proceso',
    ],
  ];

  dataSource = new MatTableDataSource<EcommerceReportDTO>();
  @ViewChild(MatPaginator) paginator: MatPaginator;

  constructor(
    private formBuilder: FormBuilder,
    private adminStore: AdminStore,
    private dialog: MatDialog,
    private cdr: ChangeDetectorRef,
    private customValidators: CustomValidatorsService,
    private excelService: ExcelService,
    private translateService: TranslateService,
    private datepickerUtils: DatepickerUtilsService
  ) {}

  ngOnInit(): void {
    this.ecommerceForm = this.formBuilder.group(
      {
        numOperation: ['', Validators.required],
        nif: [''],
        idEcommerce: [''],
        name: ['', Validators.required],
        firstName: [''],
        lastName: [''],
        guid: [''],
        initialDate: ['', Validators.required],
        finalDate: ['', Validators.required],
        dateUpdate: [''],
      },
      { validators: [this.customValidators.isDateValid('initialDate', 'finalDate', 'dateInvalid')] }
    );

    this.translateService.currentLang === LOCALE_ES ? this.datepickerUtils.spanish() : this.datepickerUtils.catalan();
    this.translateService.onLangChange
      .pipe(untilDestroyed(this))
      .subscribe((event) =>
        event.lang === LOCALE_ES ? this.datepickerUtils.spanish() : this.datepickerUtils.catalan()
      );

    this.ecommerceForm.controls.initialDate?.statusChanges.subscribe((status) => {
      if (status === 'VALID') {
        this.minDate = this.ecommerceForm.controls.initialDate?.value;
        if (this.ecommerceForm.controls.initialDate.value) {
          const dateInitValue = this.ecommerceForm.controls.initialDate.value.clone();
          this.maxFinalDate = dateInitValue.add(12, 'months').toDate();
        }
      }
    });

    this.ecommerceForm.controls.numOperation.statusChanges.subscribe((status) => {
      const propsKeys = ['name'];
      this.validateOrResetForm(propsKeys, status, this.ecommerceForm.controls.numOperation.value);
    });

    this.ecommerceForm.controls.name.statusChanges.subscribe((status) => {
      const propsKeys = ['numOperation'];
      this.validateOrResetForm(propsKeys, status, this.ecommerceForm.controls.name.value);
    });
  }

  private validateOrResetForm(controls: string[], status: string, currentValue: string) {
    console.log('currentValue', currentValue);
    if (status === 'VALID' && currentValue) {
      controls.forEach((key) => {
        this.ecommerceForm.controls[key].setValidators(null);
        if (this.ecommerceForm.controls[key].errors) {
          this.ecommerceForm.controls[key].setErrors(null);
        }
      });
    } else if (status === 'INVALID') {
      controls.forEach((key) => {
        this.ecommerceForm.controls[key].setValidators(Validators.required);
        if (!this.ecommerceForm.controls[key].errors) {
          this.ecommerceForm.controls[key].setErrors({ required: true });
        }
      });
    } else {
      if (!currentValue) {
        controls.forEach((key) => {
          if (!this.ecommerceForm.controls[key].value) {
            this.ecommerceForm.controls[key].setValidators(Validators.required);
            if (!this.ecommerceForm.controls[key].errors) {
              this.ecommerceForm.controls[key].setErrors({ required: true });
            }
          }
        });
      }
    }
  }

  consult(): void {
    this.dataSource.data = [];
    this.adminStore
      .getReportsECommerce(this.ecommerceForm)
      .then(
        (data) => {
          console.log(data);
          this.dataSource.data = data;
        },
        (error) => {
          console.error(error);
        }
      )
      .finally(() => {
        this.hasCalledOnce = true;
        this.cdr.detectChanges();
        this.dataSource.paginator = this.paginator;
      });
  }

  getDetailEcommerce(reportEcommerce: EcommerceReportDTO): void {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.width = '100%';
    dialogConfig.maxWidth = '700px';

    this.adminStore.getReportsDetailECommerce(reportEcommerce).then(
      (data) => {
        dialogConfig.data = { data: data };
        this.dialog.open(DetailEcommerceDialog, dialogConfig);
      },
      (error) => console.error(error)
    );
  }

  getDetailEcommerceTPV(reportEcommerce: EcommerceReportDTO): void {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.width = '100%';
    dialogConfig.maxWidth = '700px';
    this.adminStore.getReportsDetailTPVECommerce(reportEcommerce).then(
      (data) => {
        dialogConfig.data = { data: data };
        this.dialog.open(DetailTpvEcommerceDialog, dialogConfig);
      },
      (error) => console.error(error)
    );
  }

  getDetailDigitalSignature(reportEcommerce: EcommerceReportDTO): void {
    const request: FormGroup = this.formBuilder.group({
      numOperation: [''],
      nif: [''],
      guid: [reportEcommerce.guid],
    });
    this.adminStore
      .resultsSignatureReport(request)
      .then((data) => {
        if (data && data?.digitalSignReportVO.length > 0) {
          console.log(data);
          const dialogConfig = new MatDialogConfig();
          dialogConfig.width = '100%';
          dialogConfig.maxWidth = '800px';
          dialogConfig.data = { data: data.digitalSignReportVO[0] };
          this.dialog.open(DetailSignatureDigitalDialog, dialogConfig);
        }
      })
      .catch((error) => console.error(error));
  }

  createPdf() {
    try {
      let doc = new jsPDF({
        orientation: 'portrait',
        format: [296.672, 594.106],
        unit: 'mm',
      });

      /* HEADER */
      doc.setProperties({
        title: 'Informe Ecommerce',
      });

      const pageWidth = doc.internal.pageSize.width;

      doc.setFontSize(24);
      doc.setTextColor('1E90FF');
      doc.text('Informe Ecommerce', pageWidth / 2, 25, { align: 'center' });

      doc.setFontSize(10);
      doc.setTextColor('#000000');
      doc.text(new Date().toUTCString().replace('GMT', ''), pageWidth / 2, 32, { align: 'center' });

      doc.setFontSize(14);
      doc.text('Datos de la Solicitud', 14, 47);

      /* BODY */
      const dataPdf: Array<string[]> = this.dataSource.data.map((ecommerceReport) => {
        return [
          ecommerceReport.idEcommerce,
          ecommerceReport.guid,
          ecommerceReport.numOperacion,
          ecommerceReport.codAutorization,
          ecommerceReport.orderReference?.toString(),
          ecommerceReport.guidCheckLgty,
          ecommerceReport.guidContract?.toString(),
          ecommerceReport.name + ' ' + ecommerceReport.lastname1 + ' ' + ecommerceReport.lastname2,
          ecommerceReport.stateProcess,
        ];
      });
      console.log(this.head);
      console.log(dataPdf);

      autoTable(doc, {
        startY: 50,
        head: this.head,
        headStyles: { fillColor: '#969696' },
        rowPageBreak: 'avoid',
        body: dataPdf,
      });

      doc.save('InformeEcommerce_' + moment().locale('es').format('DDMMYYYY') + '.pdf');
    } catch (error) {
      console.error(error);
    }
  }

  createExcel() {
    let dataForExcel: any[] = this.dataSource.data.map((row: EcommerceReportDTO) => {
      return [
        row.idEcommerce,
        row.guid,
        row.numOperacion,
        row.codAutorization,
        row.orderReference,
        row.guidCheckLgty,
        row.guidContract,
        row.name,
        row.stateProcess,
      ];
    });
    const fileName = 'InformeEcommerce_' + moment().locale('es').format('DDMMYYYY');
    const excelData = {
      headers: this.head[0],
      fileName: fileName,
      data: dataForExcel,
    };
    this.excelService.exportExcel(excelData, 'Informe E-commerce');
  }
}
